<template>
    <div>
        <el-dialog v-model="dialogVisible" class="custom-dialog" :before-close="handleClose" center>

            <h3 style="text-align: center; color: #fff; font-size: 18px ">{{loadingTitle}}</h3>
            <el-form   :inline="false" :model="formData" :rules="rules" ref="rulesForm" label-position="right"
                label-width="auto" style="margin-top: 30px;">
                <el-form-item label="用户名称:" prop="name" class="form-input_class">
                    <el-input v-model.trim="formData.name" maxlength="30" class="form-input_class1"
                        placeholder="请输入用户名称"></el-input>
                </el-form-item>
                <el-form-item label="手机号:" prop="phone" class="form-input_class">
                    <el-input v-model.trim="formData.phone" maxlength="30" placeholder="请输入手机号"
                        class="form-input_class1"></el-input>
                </el-form-item>
                <!-- <el-form-item label="密码:" prop="password" class="form-input_class">
                    <el-input v-model.trim="formData.password" maxlength="30" placeholder="请输入密码"
                        class="form-input_class1" type="password"></el-input>
                </el-form-item>
                <el-form-item label="确认密码:" prop="repassword" class="form-input_class">
                    <el-input v-model.trim="formData.repassword" maxlength="30" placeholder="请再次输入密码"
                        class="form-input_class1" type="password" ></el-input>
                </el-form-item> -->

 

                <el-form-item label="所属部门:" prop="depart" class="form-input_class">
                    <el-select v-model="formData.depart" placeholder="请选择部门" size="default" clearable
                        class="form-input_class1">
                        <el-option v-for="item in branchFactoryList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="用户类型:" prop="role" class="form-input_class">
                    <el-select v-model="formData.role" placeholder="请选择用户类型" size="default" clearable
                        class="form-input_class1">
                        <el-option v-for="item in userole" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label="推送配置:" prop="sub_types" class="form-input_class">
                    <el-checkbox-group v-model="formData.sub_types"  >
                        <el-checkbox v-for="(alarm,index) in alarmsType" :key="index" :label="'选择'+index" :value="alarm">
                            {{ alarm}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            
            </el-form>

            <el-col :span="24" style="text-align: center; height: 30px; margin-top: 15px;margin-bottom: 40px;">
                <el-button type="primary" @click="submitData(subtype)" :loading="loadingSave"
                    style="width: 100px;">确定</el-button>
              
                <el-button @click="handleClose" style="color: black;width: 100px;">取消</el-button>
            </el-col>




        </el-dialog>
    </div>
</template>

<script>
    import {apiAddWxuser,apiWxuserUpdate} from "@/api/api";

    export default {
     
        emits: ['refreshData'],
        name: "addUser",
        data() {
            return {
                dialogVisible:false,
                loadingSave:false,
                loadingTitle:'',
                formData:{
                    id:'',
                    name:'',
                    phone:'',
                   // password:'',
                   // repassword:'',
                    depart:'',
                    role:'',
                    sub_types:[],
                },
                subtype:0,
                rules:{
                    name: [
                        {required: true, message: '请输入用户名称',trigger: 'blur'}
                    ],
                    phone: [
                        {required: true, message: '请输入用户手机号',trigger: 'blur'}
                    ],
                    // password: [
                    //     {required: true, validator:(rule,value,callback) =>{
                    //       if(value ==''){
                    //         callback(new Error('请输入密码'))
                    //       }else{
                    //         if (this.formData.repassword !== '') {
                    //             this.$refs.rulesForm.validateField('repassword')
                    //         }
                    //         callback()
                    //       }
                    //     } 
                            
                    //     ,trigger: 'blur'}
                    // ],
                    // repassword: [
                       
                    //     {required: true,
                    //     validator: (rule, value, callback) => {
                    //         if (value === '') {
                    //         callback(new Error('请再次输入密码'))
                    //         } else if (value !== this.formData.password) {
                    //         callback(new Error('两次输入密码不一致!'))
                    //         } else {
                    //         callback()
                    //         }
                    //     },
                    //     trigger: 'blur'
                    // }
                    // ],
                    depart: [
                        {required: true, message: '请输入部门',trigger: 'blur'}
                    ],
                    role: [
                        {required: true, message: '请输入用户类型',trigger: 'blur'}
                    ],
                 
                },
                branchFactoryList:[
                    {id:1,name:'宜化公司'},
                    {id:2,name:'设备管理部'},
                    {id:3,name:'维修分厂'},
                    {id:4,name:'电仪部'},
                    {id:5,name:'PVC分厂'},
                    {id:7,name:'电石分厂'},
                    {id:8,name:'原料分厂'},
                    {id:9,name:'烧碱分厂'},
                    {id:10,name:'合成分厂'},
                    {id:11,name:'乙炔分厂'},
                ],
                userole:[
                    {id:1,name:"管理员"},
                    {id:2,name:"用户"}
                ],
                alarmsType : ['高报','高高报','智能报警','超时未处理']
            }
        },
        methods:{
            handleClose() {
                this.dialogVisible=false
                this.loadingSave=false
              
                
                this.formData={
                    name:'',
                    phone:'',
                    depart:'',
                    role:'',
                    sub_types:[],
                }
            },
           
            addDeviceFn(item,flag) {
                this.loadingTitle=flag
                this.dialogVisible=true
                
                
                
                if(item){
                    this.subtype =1
                    this.formData.id = item.id
                    this.formData.name = item.name
                    this.formData.phone = item.phone_number
                    this.formData.depart = item.depart
                    const binsub = item.sub_types.toString(2).padStart(4, "0")
                   
                   
                    binsub.split('').forEach((bit,index) => {
                        if(bit=='1'){
                            this.formData.sub_types.push(`选择${3-index}`) 
                        }
                    });
                  
                    switch(item.depart){
                        case "1":  this.formData.depart = "宜化公司";break;
                        case "2":  this.formData.depart= "设备管理部";break;
                        case "3": this.formData.depart= "维修分厂" ;break;
                        case "4":  this.formData.depart= "电仪部";break;
                        case "5":  this.formData.depart= "PCV分厂";break;
                        case "6": this.formData.depart= "电石分厂" ;break;
                        case "7":  this.formData.depart= "原料分厂";break;
                        case "8":  this.formData.depart= "烧碱分厂";break;
                        case "9": this.formData.depart= "合成分厂" ;break;
                        case "10": this.formData.depart= "乙炔分厂";break;


                    }
                    
                }
                else{
                    this.subtype =0
                    this.formData={
                    name:'',
                    phone:'',
                    depart:'',
                    role:'',
                    sub_types:[],
                }
                }
            
            
                
                
            },
            getBranchFactory(factory){
                switch(factory){
                    case 1: return this.branchFactoryList[0].name;
                    case 2: return this.branchFactoryList[1].name;
                    case 3: return this.branchFactoryList[2].name;
                    case 4: return this.branchFactoryList[3].name;
                    case 5: return this.branchFactoryList[4].name;
                    case 6: return this.branchFactoryList[5].name;
                    default :return "未知分厂";
                }
            },
            submitData(subtype) {
            
               
                this.$refs['rulesForm'].validate(obj=>{
                    if(obj) {
                        this.loadingSave=false
                      
                        let sub_type = 0
                        if((this.formData.sub_types).length>0){
                            for (let item =0;item<(this.formData.sub_types).length;item++){
                             
                                
                                if(this.formData.sub_types[item] =="选择0"){
                                    sub_type = sub_type | 1
            
                                }
                             
                                if(this.formData.sub_types[item] == "选择1")
                                {
                                    sub_type = sub_type | 2
                                   
                                }
                                if(this.formData.sub_types[item] == "选择2")
                                {
                                    sub_type = sub_type | 4  
                                    
                                }
                                if(this.formData.sub_types[item] == "选择3")
                                {
                                    sub_type = sub_type | 8
                                  
                                }
                        } 
                        } 
                        else{
                            sub_type = 0
                        }
                        
                        let parm_device = {
                            id:this.formData.id,
                            name: this.formData.name,
                            phone_number:this.formData.phone,
                            depart: this.formData.depart,
                            role:this.formData.role,
                            sub_types:sub_type,
                          
                        }
                        // 新增用户
                        if(subtype==0){

                            apiAddWxuser(parm_device).then(res=>{
                            this.loadingSave=false
                            if(res.data.code ==201) {
                                this.$message.success("创建成功")
                                this.handleClose()
                                    this.$emit('refreshData')
                            }else{
                                if(res.data.msg)
                                this.$message.warning("添加用户失败")
                            }
                            }).catch( error =>{
                                this.loadingSave=false
                                this.$message.warning("添加用户失败")

                            })

                        }
              
                      //修改用户
                      if(subtype ==1){

                        apiWxuserUpdate(parm_device).then(res=>{
                            console.log("修改修改",res.data);
                            
                            this.loadingSave=false
                            if(res.code == 200) {
                                this.$message.success("修改成功")
                                this.handleClose()
                                this.$emit('refreshData')
                            }else{
                                if(res.data.msg)
                                this.$message.warning("修改成功")
                            }
                            }).catch( error =>{
                                this.loadingSave=false
                                this.$message.warning("修改成功")

                            })

                        }
                       
                    }
                })
            },
        }
    }
</script>

<style lang="scss"  scoped >

 :deep(.custom-dialog)  {
 
    width: 600px;
    
    background: url("@/assets/bigscreen/alarm_handle.png") no-repeat center center;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
   

 }
:deep(.el-input__wrapper){
    background-color: #fff;
   
}
:deep(.el-input__inner){
    color: black;
   
}

.form-input_class1{
  
 
    width:400px;
}



.form-input_class{
    margin-top:10px ;
    margin-left: auto;
    margin-right: auto;
    width:480px;
  
    
}

</style>